type SkeletonProps = {
  className?: string;
};

/**
 * A grey placeholder block. Use it to hold the shape of content that hasn't
 * arrived yet, so a panel keeps its size instead of the page jumping when the
 * real data lands.
 */
export const Skeleton = ({ className = "" }: SkeletonProps) => (
  <div
    className={`animate-pulse rounded bg-gray-200 ${className}`}
    aria-hidden
  />
);

/** Placeholder for the small "label + big number" cards at the top of a page. */
export const SkeletonStatCard = () => (
  <div className="bg-white rounded-xl px-4 py-3 flex flex-col gap-2">
    <Skeleton className="h-3 w-24" />
    <Skeleton className="h-6 w-16" />
  </div>
);

type SkeletonRowsProps = {
  /** How many placeholder rows to draw. Match the usual row count so the
   *  panel doesn't visibly resize once the data arrives. */
  rows?: number;
  /** Rendered above the rows, for tables that show a header while loading. */
  className?: string;
};

/** Placeholder for a list or table body. */
export const SkeletonRows = ({ rows = 5, className = "" }: SkeletonRowsProps) => (
  <div className={`divide-y divide-gray-border ${className}`} role="status" aria-label="Loading">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="flex items-center justify-between px-5 py-3.5">
        <Skeleton className="h-3.5 w-40" />
        <Skeleton className="h-3.5 w-10" />
      </div>
    ))}
  </div>
);
